import { render, staticRenderFns } from "./TailModule.vue?vue&type=template&id=70f97206&"
import script from "./TailModule.vue?vue&type=script&lang=js&"
export * from "./TailModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports